// AUTOLOAD CODE BLOCK (MAY BE CHANGED OR REMOVED)
// autoload code modified to using data-rel attribute see https://www.growse.com/2012/02/28/making-slimbox2-play-nice-with-html5/

if (!/android|iphone|ipod|series60|symbian|windows ce|blackberry/i.test(navigator.userAgent)) {
	jQuery(function($) {
		$("a[data-rel^='lightbox']").slimbox({ counterText: "{x}/{y}", closeHint: "Zavřít (Esc, C, X)", prevHint: "Předchozí (<-, P)", nextHint: "Následující (->, N)", resizeDuration: 250, scaler: 0.8 }, null, function(el) {
      return (this == el) || ((this.attributes['data-rel'].value.length > 8) && (this.attributes['data-rel'].value == el.attributes['data-rel'].value));
		});
	});
}